import React, { useState, useEffect, useRef } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import {
    getReportTemplateParameter,
    createNewReport,
    updateReport,
    getUpdatedCustomerReportData,
    updateNiptDob,
    createNiptDob,
} from "../../../actions/LimsAdminActions";
import { useNavigate, useParams } from "react-router-dom";
import ReactToPrint from "react-to-print";
import QRCode from "react-qr-code";
import "./style.css";
import logo from "../../../../redcliffe_logo.jpeg";
import callIcon from "../../../../callicon.png";
import maillIcon from "../../../../mailicon.png";
import browserIcon from "../../../../browsericon.png";
import { Paper } from "@mui/material";
import Grid from '@mui/material/Grid';
import { Select, MenuItem, TextField } from '@material-ui/core';
import moment from "moment";
import { green } from "@mui/material/colors";
import { connect } from "react-redux";
import NpsRating from "../../NPS";
import { Grammarly, GrammarlyEditorPlugin } from "@grammarly/editor-sdk-react";

const useStyles = makeStyles((theme) =>
    createStyles({
        paper: {
            width: "100%",
        },
        centerIt: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        fontWeight: {
            fontWeight: "bold",
        },
        textCenter: {
            textAlign: "center",
        },
        endIt: {
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
        },
        belowIt: {
            display: "flex",
            alignItems: "flex-end",
        },
        line: {
            borderBottom: "5px solid red",
            marginTop: "5px",
            width: "90%",
        },
        inputFiled: {
            outline: "none",
        },
        input: {
            padding: "1px",
            direction: "rtl",
        },
    })
);
interface Props {
    reportListParameter: any;
    getReportTemplateParameter: any;
    bookingId: any;
    reportData: any;
    createNewReport: any;
    updateReport: any;
    getUpdatedCustomerReportData: any;
    updateNiptDob: any;
    createNiptDob: any;
}
const HbbReport: React.FC<Props> = ({
    getReportTemplateParameter,
    reportListParameter,
    bookingId,
    reportData,
    createNewReport,
    updateReport,
    getUpdatedCustomerReportData,
    updateNiptDob,
    createNiptDob,
}) => {
    const componentRef = useRef<any>(null);
    const { firstP, secondP, thirdP } = useParams<any>();
    const classes = useStyles();
    const navigator = useNavigate();
    const [status, setStatus] = useState<string>(reportListParameter?.status);
    const [dob, setDob] = useState<any>("");
    const [age, setAge] = useState<any>("");
    const [Sample_Received, setSample_Received] = useState<any>("");
    const [Sample_Receivedtime, setSample_Receivedtime] = useState<any>("");
    const [Sample_Collected, setSample_Collected] = useState<any>("");
    const [designation, setdesignation] = useState<any>("");
    const [Name, setName] = useState<any>("");
    const [Gender, setGender] = useState<any>("");
    const [uuid, setUuid] = useState<any>("");
    const reactToPrintContent = React.useCallback(() => {
        return componentRef.current;
    }, [componentRef.current]);

    const reactToPrintTrigger = React.useCallback(() => {
        return (
            <button
                style={{ marginLeft: "10px", background: "#b02613", color: "white" }}
            >
                Print Report
            </button>
        );
    }, []);

    const [userInput, setUserInput] = useState("");

    const handleInputChange = (e: { target: { value: React.SetStateAction<string>; }; }) => {
        setUserInput(e.target.value);
    };

    //Report Data
    const [Hbb, setHbb] = useState<any>([])
    useEffect(() => {
        const data: any = []
        if (reportListParameter && reportListParameter?.booking && reportListParameter?.booking.length > 0) {
            reportListParameter?.booking?.map((list: any) => {
                data?.push({ ...list });
            })
        }
        setHbb(data);
    }, [reportListParameter])


    useEffect(() => {
        if (thirdP !== "add") {
            getUpdatedCustomerReportData(`booking_id=${firstP}&template_id=${secondP}`)
        } else {
            getReportTemplateParameter(`booking_id=${firstP}&template_id=${secondP}`);
        }
    }, [])

    //Booking Data
    const [HbbReport, setHbbReport] = useState<any>([])
    useEffect(() => {
        const data: any = []
        if (reportListParameter && reportListParameter?.booking && reportListParameter?.booking.length > 0) {
            reportListParameter?.booking?.map((list: any) => {
                data?.push({ ...list });
            })
        }
        setHbbReport(data);
    }, [reportListParameter])


    useEffect(() => {
        setSample_Collected(HbbReport[0]?.collection_date);
        setSample_Receivedtime(HbbReport[0]?.pickup_time);
        setdesignation(HbbReport[0]?.designation);
        setGender(HbbReport[0]?.customer_gender);
        setSample_Received(HbbReport[0]?.pickup_date);
        setName(HbbReport[0]?.customer_name);
        setAge(HbbReport[0]?.customer_age);
        setDob(HbbReport[0]?.dob);
        setUuid(HbbReport[0]?.uuid);
    }, [HbbReport]);

    useEffect(() => {
        if (dob) {
            const currentDate = new Date();
            const dobDate = new Date(dob);
            const ageInMilliseconds = currentDate.getTime() - dobDate.getTime();
            const ageInYears = Math.floor(ageInMilliseconds / (1000 * 60 * 60 * 24 * 365));
            setAge(ageInYears);
        }
        else {

            setAge(HbbReport[0]?.customer_age);
        }
    }, [dob]);


    //Lmp
    const [lmp, setLmp] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.lmp_date &&
            reportListParameter?.lmp_date.length > 0
        ) {
            reportListParameter?.lmp_date?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setLmp(data);
    }, [reportListParameter]);

    const updateLmp = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...lmp]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setLmp(storeData);
    }

    // Hospital name
    const [hospitalName, setHospitalName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.hospital_name &&
            reportListParameter?.hospital_name.length > 0
        ) {
            reportListParameter?.hospital_name?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setHospitalName(data);
    }, [reportListParameter]);

    const updateHospitalName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...hospitalName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setHospitalName(storeData);
    }


    //Clincian Name
    const [clinicianName, setClinicianName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.clinical_name &&
            reportListParameter?.clinical_name.length > 0
        ) {
            reportListParameter?.clinical_name?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setClinicianName(data);
    }, [reportListParameter]);

    const updateClinicanName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...clinicianName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setClinicianName(storeData);
    }

    //Location
    const [locationName, setLocationName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.location &&
            reportListParameter?.location.length > 0
        ) {
            reportListParameter?.location?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setLocationName(data);
    }, [reportListParameter]);

    const updateLocationName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...locationName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setLocationName(storeData);
    }

    // Hospital Id
    const [HospitalId, setHospitalId] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.Hospital_Id
            &&
            reportListParameter?.Hospital_Id

                .length > 0
        ) {
            reportListParameter?.Hospital_Id

                ?.map((list: any) => {
                    data?.push({ ...list });
                });
        }
        setHospitalId(data);
    }, [reportListParameter]);

    const updateHospitalID = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...HospitalId]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setHospitalId(storeData);
    }

    //CLINICAL HISTORY
    const [HbbHistory, setHbbHistory] = useState<any>([]);
    useEffect(() => {
        const Hbbclincdata: any = [];
        if (
            reportListParameter &&
            reportListParameter?.clinical_significance
            &&
            reportListParameter?.clinical_significance
                ?.length > 0
        ) {
            reportListParameter?.clinical_significance
                ?.map((list: any) => {
                    Hbbclincdata?.push({ ...list });
                });
        }
        setHbbHistory(Hbbclincdata);
    }, [reportListParameter]);

    const updateHistory = (
        id: number,
        value: any,
        index: number,
        key: string,
        object: any) => {
        let storeData = [...HbbHistory]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value
                break;
        }
        storeData[index] = newItem;
        setHbbHistory(storeData);
    }



    //CLINICAL INDICATIONS 
    const [HbbClinData, setHbbClinData] = useState<any>([]);
    useEffect(() => {
        const Hbbclincdata: any = [];
        if (
            reportListParameter &&
            reportListParameter?.clinical_indication &&
            reportListParameter?.clinical_indication?.length > 0
        ) {
            reportListParameter?.clinical_indication?.map((list: any) => {
                Hbbclincdata?.push({ ...list });
            });
        }
        setHbbClinData(Hbbclincdata);
    }, [reportListParameter]);

    const updateClientIndication = (
        id: number,
        value: any,
        index: number,
        key: string,
        object: any) => {
        let storeData = [...HbbClinData]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value
                break;
        }
        storeData[index] = newItem;
        setHbbClinData(storeData);
    }

    // RESULTS
    let Data = [
        {
            id: 1,
            name: "NA",
            varientdetected: "NA",
            genotype: " N/A",
            allelestatus: " N/A",
            clinical: "N/A",


        },
        {
            id: 2,
            name: "NA",
            varientdetected: "NA",
            genotype: " N/A",
            allelestatus: " N/A",
            clinical: "N/A",

        },
        {
            id: 3,
            name: "NA",
            varientdetected: "NA",
            genotype: " N/A",
            allelestatus: " N/A",
            clinical: "N/A",

        },
    ];

    const [VarientResult, setVarientResult] = useState([]);

    useEffect(() => {
        let storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.result_brca &&
            reportListParameter?.result_brca.length > 0
        ) {
            reportListParameter?.result_brca?.map((list: any) => {
                storeData.push({ ...list });
            });
        }
        setVarientResult(storeData);
    }, [reportListParameter]);

    const [tableData, setTableData] = useState<any>([]);
    useEffect(() => {
        let data: any,
            parse: any,
            storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.result_brca &&
            reportListParameter?.result_brca.length > 0
        ) {
            data = reportListParameter?.result_brca[0]?.parameter_value;
            if (data) {
                parse = JSON.parse(data);
            }
            if (parse?.length > 0) {
                parse?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            }
            else {
                Data?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            }
        }
        setTableData(storeData);
    }, [reportListParameter]);

    const updateRow = (index: number, key: string, value: any, object: any) => {
        let storeData = [...tableData];
        let newItem = storeData[index];
        switch (key) {
            case "name":
                newItem.name = value;
                break;
            case "varientdetected":
                newItem.varientdetected = value;
                break;
            case "genotype":
                newItem.genotype = value;
                break;
            case "allelestatus":
                newItem.allelestatus = value;
                break;
            case "clinical":
                newItem.clinical = value;
                break;

            default:
                break;



        }
        storeData[index] = newItem;
        setTableData(storeData);
    };

    // Interpretation
    const [HbbInterpretation, setHbbInterpretation] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.interpretation
            &&
            reportListParameter?.interpretation
                .length > 0
        ) {
            reportListParameter?.interpretation
                ?.map((list: any) => {
                    data?.push({ ...list });
                });
        }
        setHbbInterpretation(data);
    }, [reportListParameter]);

    const updateInterpretation = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...HbbInterpretation]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setHbbInterpretation(storeData);
    }

    // REmark 1
    const [HbbRemark, setHbbRemark] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.remarks2

            &&
            reportListParameter?.remarks2

                .length > 0
        ) {
            reportListParameter?.remarks2

                ?.map((list: any) => {
                    data?.push({ ...list });
                });
        }
        setHbbRemark(data);
    }, [reportListParameter]);

    const updateRemark = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...HbbRemark]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setHbbRemark(storeData);
    }

    // Remark 2
    const [HbbRemark1, setHbbRemark1] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.remarks1

            &&
            reportListParameter?.remarks1

                .length > 0
        ) {
            reportListParameter?.remarks1

                ?.map((list: any) => {
                    data?.push({ ...list });
                });
        }
        setHbbRemark1(data);
    }, [reportListParameter]);

    const updateRemark1 = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...HbbRemark1]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setHbbRemark1(storeData);
    }


    //RECOMMANDATION
    const [HbbRecommandation, setHbbRecommandation] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.recommendations &&
            reportListParameter?.recommendations.length > 0
        ) {
            reportListParameter?.recommendations?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setHbbRecommandation(data);
    }, [reportListParameter]);

    const updateRecommendation = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...HbbRecommandation]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setHbbRecommandation(storeData);
    }


    //doctor list
    const [HbbdoctorList, setHbbdoctorList] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.doctor_list &&
            reportListParameter?.doctor_list.length > 0
        ) {
            reportListParameter?.doctor_list?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setHbbdoctorList(data);
    }, [reportListParameter]);

    const updateDoctorList = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...HbbdoctorList]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setHbbdoctorList(storeData);
    }

    //Sample Type
    const [sampletype, setsampletype] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.sample_type &&
            reportListParameter?.sample_type.length > 0
        ) {
            reportListParameter?.sample_type?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setsampletype(data);
    }, [reportListParameter]);

    const updateSampletype = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...sampletype]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setsampletype(storeData);
    }


    //Submit Data
    const submitData = async (e: any) => {
        e.preventDefault();

        let storeData: any = [];

        if (lmp.length > 0) {
            lmp?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (HbbReport.length > 0) {
            HbbReport?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (Hbb.length > 0) {
            Hbb?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (HbbHistory.length > 0) {
            HbbHistory?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }


        if (HbbClinData.length > 0) {
            HbbClinData?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (HbbRecommandation.length > 0) {
            HbbRecommandation?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        if (HbbInterpretation.length > 0) {
            HbbInterpretation?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }



        if (HbbdoctorList.length > 0) {
            HbbdoctorList?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (HbbRemark.length > 0) {
            HbbRemark?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (HbbRemark1.length > 0) {
            HbbRemark1?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }



        if (hospitalName.length > 0) {
            hospitalName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (clinicianName.length > 0) {
            clinicianName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (locationName.length > 0) {
            locationName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (HospitalId.length > 0) {
            HospitalId?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        if (sampletype.length > 0) {
            sampletype?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        const stringify = JSON.stringify(tableData);
        if (VarientResult.length > 0) {
            VarientResult?.map((list: any) => {
                storeData.push({
                    ...list,
                    parameter_value: stringify,
                });
            });
        }
        const reportData = {
            template_id: secondP,
            booking_id: firstP,
            case_id: firstP,
            template_parameter: storeData,
            dob: dob,
            status: status,
            customer_age: age,
            collection_date: Sample_Collected,
            pickup_date: Sample_Received,
            pickup_time: Sample_Receivedtime,
            customer_gender: Gender,
            customer_name: Name,
            designation: designation,
        };
        const reportEditData = {
            template_id: secondP,
            booking_id: firstP,
            case_id: firstP,
            status: status,
            template_parameter: storeData,
            dob: dob,
            customer_age: age,
            collection_date: Sample_Collected,
            pickup_date: Sample_Received,
            pickup_time: Sample_Receivedtime,
            customer_gender: Gender,
            customer_name: Name,
            designation: designation,
        };

        if (thirdP === "add") {
            await createNewReport(reportData);
            navigator('/dashboard/la');
        } else if (thirdP === "edit") {
            await updateReport(reportListParameter?.id, reportEditData);
            if (thirdP === "edit") {
                if (dob || age || Sample_Collected || Sample_Received || Sample_Receivedtime || Gender || designation || Name || status) {
                    await updateNiptDob(reportListParameter?.id, { dob, age, Sample_Collected, Sample_Received, Sample_Receivedtime, Gender, designation, Name, status });
                } else {
                    console.error("Missing dob value for updateNiptDob");
                }
            } else {
                await createNiptDob(reportListParameter?.id, {
                    dob, age, Sample_Collected, Sample_Received, Sample_Receivedtime, Gender, designation, Name, status
                });
            }
        }
    };

    const [isInputFocused, setInputFocused] = useState(false);

    const handleInputFocus = () => {
        setInputFocused(true);
    };

    const handleInputBlur = () => {
        setInputFocused(false);
    };

    const [uhid, setuhid] = useState<any>([]);
     const [tempCode, setTempCode] = useState<any>([]);
    useEffect(() => {
        setuhid(reportListParameter?.uhid)
        setTempCode(reportListParameter?.template_code)
    }, [reportListParameter])
    const documentTitle = `${HbbReport[0]?.pk}_${Name?.replace(/[\/\s]/g, '_')}_${uhid}_${tempCode}`;

    return (
        <Grammarly clientId="client_6FRQR4cCPSqwqzYEfgQCbq">
            <div style={{ margin: "55px auto" }}>
                <div>
                    <div style={{ height: "20px" }}>
                        <div>
                            {thirdP !== "add" && (
                                <ReactToPrint
                                    content={reactToPrintContent}
                                    trigger={reactToPrintTrigger}
                                    documentTitle={documentTitle}
                                />
                            )}
                        </div>
                    </div>
                    <div style={{ width: "200px", marginLeft: "780px" }}>
                        <TextField
                            id="outlined-select-currency"
                            select
                            variant="outlined"
                            fullWidth
                            className={classes.input}
                            label="Select Report Type"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                            style={{ height: "30px" }}
                        >
                            <MenuItem value={"Draft"}>Draft</MenuItem>
                            <MenuItem value={"Editable"}>Editable</MenuItem>
                            <MenuItem value={"Approved"}>Approved</MenuItem>
                            <MenuItem value={"Hold"}>Hold</MenuItem>
                            <MenuItem value={"Cancelled"}>Cancelled</MenuItem>
                        </TextField>
                    </div>

                    <div style={{ height: "20px", marginLeft: "1000px", marginBottom: "20px" }}>
                        <div>
                            <button style={{ background: "#142c96", color: "white", width: "100px", height: "40px", marginTop: "-10px" }} disabled={status === ""} onClick={submitData}>Submit</button>
                        </div>
                    </div>
                </div>
                <div
                    id="PAGE"
                    ref={componentRef}
                    style={{
                        width: 1122,
                        background: "#fff",
                    }}
                >
                    {/* header section */}
                    <div className="Hbb-page-header">
                        <div style={{ padding: "20px" }}>
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    background: "#fff",
                                }}
                            >
                                <div style={{ width: "80%", padding: 15 }}>
                                    <div
                                        style={{
                                            color: "#1A5276",
                                            fontWeight: "bold",
                                            fontSize: "30px",
                                            textAlign: "left",
                                        }}
                                    >
                                        LABORATORY REPORT
                                    </div>
                                </div>
                                <div style={{ width: "20%", textAlign: "left", padding: 15 }}>
                                    <h3>
                                        <img src={logo} alt="logo" style={{ width: "200px" }} />
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="Hbb-main-content4">.</div>
                    <br />
                    <div
                        style={{
                            fontSize: "35px",
                            // color: "#73016d",
                            textAlign: "center",
                            marginBottom: "20px"
                        }}
                    >
                        <span style={{ fontWeight: "bold", color: "#750b1e" }}>HBB</span>
                    </div>
                    {/* <div className="Hbb-main-content3">.</div> */}
                    {/* patient details page 1 */}
                    <Paper style={{ backgroundColor: "#F8F8F8", width: "96%", marginLeft: "18px", marginTop: "13px", }}>
                        <Grid container spacing={2} style={{ fontWeight: "bold", fontSize: "15px", marginTop: "-20px" }} className="Hbb-marginLeft-c">
                            <Grid item xs={4}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Patient ID
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {HbbReport[0]?.pk
                                                ? HbbReport[0]?.pk
                                                : "NA"}
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Patient Name
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : <input
                                                className="input"

                                                style={{ border: "none", width: designation ? `${(designation.length + 1) * 8}px` : "20px", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                value={designation}
                                                onChange={(e) => setdesignation(e.target.value)}
                                            />
                                            <input
                                                className="input"
                                                style={{ border: "none", width: "70%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                value={Name}
                                                onChange={(e) => setName(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>

                                        <Grid item xs={3.5}>
                                            Patient DOB
                                        </Grid><Grid item xs={8.5}>
                                            : <input
                                                className="input"
                                                style={{ border: "none", width: "65%", textAlign: "start", appearance: "none", background: "none", marginLeft: "2px", fontWeight: "bold" }}
                                                type="text"
                                                value={dob}
                                                placeholder={isInputFocused ? 'YYYY-MM-DD' : ''}
                                                onChange={(e) => {
                                                    setDob(e.target.value);
                                                }}
                                                onFocus={handleInputFocus}
                                                onBlur={handleInputBlur} />
                                        </Grid>
                                    </div>
                                </Grid>

                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Age
                                        </Grid>
                                        {dob === "" || dob === null ? (
                                            <Grid item xs={8.5}>
                                                :
                                                {(HbbReport[0]?.customer_name.includes('Af') ||
                                                    HbbReport[0]?.customer_name.includes('AF') ||
                                                    HbbReport[0]?.customer_name.includes('CVS') ||
                                                    HbbReport[0]?.customer_name.includes('Cvs') ||
                                                    HbbReport[0]?.customer_name.includes('POC') ||
                                                    HbbReport[0]?.customer_name.includes('Poc') ||
                                                    HbbReport[0]?.customer_name.includes('FETUS') ||
                                                    HbbReport[0]?.customer_name.includes('Fetus') ||
                                                    HbbReport[0]?.customer_name.includes('F/O'))
                                                    ? 'NA'
                                                    : <> <input
                                                        className="input"
                                                        style={{ border: "none", width: "12%", textAlign: "start", appearance: "none", background: "none", marginLeft: "2px", fontWeight: "bold" }}
                                                        type="text"
                                                        value={age}
                                                        onChange={(e) => setAge(e.target.value)} />Y
                                                    </>
                                                }
                                            </Grid>
                                        ) : (
                                            <Grid item xs={8.5}>
                                                :
                                                {(HbbReport[0]?.customer_name.includes('Af') ||
                                                    HbbReport[0]?.customer_name.includes('AF') ||
                                                    HbbReport[0]?.customer_name.includes('CVS') ||
                                                    HbbReport[0]?.customer_name.includes('Cvs') ||
                                                    HbbReport[0]?.customer_name.includes('POC') ||
                                                    HbbReport[0]?.customer_name.includes('Poc') ||
                                                    HbbReport[0]?.customer_name.includes('FETUS') ||
                                                    HbbReport[0]?.customer_name.includes('Fetus') ||
                                                    HbbReport[0]?.customer_name.includes('F/O'))
                                                    ? 'NA'
                                                    :
                                                    <span> {age} Y</span>

                                                }
                                            </Grid>
                                        )
                                        }
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            GA/LMP Date
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            :{lmp?.map((list: any, index: number) => {
                                                return (
                                                    // <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateLmp(list?.id, e.target.value, index, "free_text", list)} />
                                                    <input
                                                        style={{
                                                            border: "none",
                                                            width: "97%",
                                                            background: "none",
                                                            fontWeight: "bold",
                                                        }}
                                                        value={list?.parameter_value}
                                                        onChange={(e: any) => updateLmp(list?.id, e.target.value, index, "free_text", list)}
                                                    />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                            {/* rest half page---------------------------> */}
                            <Grid item xs={4.6}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Gender
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {(HbbReport[0]?.customer_name.includes('Af') ||
                                                HbbReport[0]?.customer_name.includes('AF') ||
                                                HbbReport[0]?.customer_name.includes('CVS') ||
                                                HbbReport[0]?.customer_name.includes('Cvs') ||
                                                HbbReport[0]?.customer_name.includes('POC') ||
                                                HbbReport[0]?.customer_name.includes('Poc') ||
                                                HbbReport[0]?.customer_name.includes('FETUS') ||
                                                HbbReport[0]?.customer_name.includes('Fetus') ||
                                                HbbReport[0]?.customer_name.includes('F/O'))
                                                ? 'NA'
                                                : <input
                                                    className="input"
                                                    style={{ border: "none", width: "65%", textAlign: "start", appearance: "none", fontWeight: "bold", background: "none" }}
                                                    type="text"
                                                    value={Gender}
                                                    onChange={(e) => setGender(e.target.value)}
                                                />}
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Clinician Name
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {clinicianName?.map((list: any, index: number) => {
                                                return (
                                                    <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateClinicanName(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Hospital Name
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {hospitalName?.map((list: any, index: number) => {
                                                return (
                                                    <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateHospitalName(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Location
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {locationName?.map((list: any, index: number) => {
                                                return (
                                                    <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateLocationName(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    {HbbReport[0]?.center?.name && HbbReport[0]?.center?.name.toUpperCase().includes("ARMC") ? (
                                        <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                            <Grid item xs={3.5}>
                                                Hospital ID
                                            </Grid>
                                            <Grid item xs={8.5}>
                                                : {HospitalId?.map((list: any, index: number) => {
                                                    return (
                                                        <input
                                                            key={list?.id}
                                                            style={{ border: "none", width: "96%", background: "none", fontWeight: "bold" }}
                                                            value={list?.parameter_value}
                                                            onChange={(e: any) => updateHospitalID(list?.id, e.target.value, index, "free_text", list)}
                                                        />
                                                    );
                                                })}
                                            </Grid>
                                        </div>
                                    ) : null}
                                </Grid>

                            </Grid>
                            {/* 3rd half  */}
                            <Grid item xs={3.4}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Sample Type
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            : {sampletype?.map((list: any, index: number) => {
                                                return (
                                                    <select name="sample" id="1" style={{ border: "none", WebkitAppearance: "none", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e) => updateSampletype(list?.id, e.target.value, index, "free_text", list)}>
                                                        <option value="normal">NA</option>
                                                        <option value="EDAT">Amniotic Fluid </option>
                                                        <option value="Venous">Chorionic Villi </option>
                                                        <option value="Arterial">Fetal Cord Blood</option>
                                                        <option value="Abortus">Product of Conception</option>
                                                        <option value="Placenta">Placenta</option>
                                                        <option value="Fetal">Fetal Cord (PUBS)</option>
                                                        <option value="Peripheral">Peripheral Blood</option>
                                                        <option value="Peripheral1">Pre Natal Cord </option>
                                                        <option value="dna">DNA</option>
                                                        <option value="blood">Blood</option>
                                                        <option value="whole blood edta"> Whole Blood EDTA </option>
                                                        <option value="ffpe tissue block"> FFPE TISSUE BLOCK </option>
                                                        <option value="Bone Marrow">Bone Marrow</option>
                                                    </select>
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Sample Collected
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            :<input
                                                className="input"
                                                style={{ border: "none", width: "75%", textAlign: "start", appearance: "none", fontWeight: "bold", background: "none" }}
                                                type="text"
                                                placeholder="yyyy-mm-dd"
                                                pattern="\d{4}-\d{2}-\d{2}"
                                                value={Sample_Collected}
                                                onChange={(e) => setSample_Collected(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Sample Received
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            : <input
                                                className="input"
                                                style={{ border: "none", width: "52%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                placeholder="yyyy-mm-dd"
                                                value={Sample_Received}
                                                onChange={(e) => setSample_Received(e.target.value)}
                                            />,
                                            <input
                                                className="input"
                                                style={{ border: "none", width: "40%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                placeholder="HH:MM:SS"
                                                value={Sample_Receivedtime}
                                                onChange={(e) => setSample_Receivedtime(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Report Released
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            : {moment.tz(Date.now(), "Asia/Kolkata").format("YYYY-MM-DD,HH:mm:ss")}
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>

                        </Grid>
                    </Paper>
                    <div style={{ width: "95%", marginLeft: "24px" }}>
                        <h6 style={{ backgroundColor: "rgb(22 55 88)", color: "white", textAlign: "center", borderBottomLeftRadius: "15px", borderBottomRightRadius: "15px", height: "35px", marginTop: "-1px", padding: "8px" }}>Test Performed:-{HbbReport[0]?.packages[0]?.name}</h6>
                    </div>
                    <div className="Hbb-br">.</div>

                    <div className="Hbb-clinical__indicatio" >
                        <span className="Hbb-clinical__subheadin" style={{ padding: "0px 10px 0px 43px" }}> CLINICAL HISTORY</span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div>
                        {HbbHistory?.map((list: any, index: number) => {
                            return (
                                <div style={{ padding: 15, textAlign: "left", marginTop: "-7px", fontSize: "17px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none", marginLeft: "32px" }}
                                            rows={3}
                                            cols={112}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateHistory(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            )
                        })}
                    </div>
                    {/* <div className="Hbb-br">.</div> */}
                    {/* clinical indication  */}
                    <div className="Hbb-clinical__indicatio" >
                        <span className="Hbb-clinical__subheadin" style={{ padding: "0px 10px 0px 43px" }}> CLINICAL INDICATION</span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div>
                        {HbbClinData?.map((list: any, index: number) => {
                            return (
                                <div style={{ padding: 15, textAlign: "left", marginTop: "-7px", fontSize: "17px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none", marginLeft: "32px" }}
                                            rows={3}
                                            cols={112}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateClientIndication(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            )
                        })}
                    </div>
                    {/* <div className="Hbb-br">.</div> */}
                    <div className="Hbb-clinical__indicatio" >
                        <span className="Hbb-clinical__subheadin" style={{ padding: "0px 10px 0px 43px" }}>RESULT</span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />

                    {/* <div style={{ width: "93%", border: "1px solid gray", marginLeft: "40px", height: "55px", }}> */}
                    <div style={{ marginLeft: "40px", display: "flex", background: "#e8eded", color: "  rgb(5, 57, 110)", fontWeight: "bolder", fontSize: "18px", height: "55px", textAlign: "center", border: "1px solid gray", width: "93%" }}>
                        <p style={{ width: "25%", textAlign: "center", borderRight: "1px solid gray", height: "55px", }}>Patient Name</p>
                        <p style={{ width: "15%", textAlign: "center", borderRight: "1px solid gray", height: "55px" }}>Varient Detected</p>
                        <p style={{ width: "15%", textAlign: "center", borderRight: "1px solid gray", height: "55px" }}>Genotype</p>
                        <p style={{ width: "25%", textAlign: "center", borderRight: "1px solid gray", height: "55px" }}>Allele Status</p>
                        <p style={{ width: "25%", textAlign: "center", height: "55px" }}>Clinical Significance</p>

                    </div>
                    {/* </div> */}
                    <div>
                        <div className="contain" style={{ border: "1px solid gray", width: "93%", marginLeft: '40px' }} >
                            {tableData?.length > 0 &&
                                tableData?.map((list: any, index: number) => {
                                    return (
                                        <>
                                            <div
                                                style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    fontSize: "14px",
                                                    height: "45px",
                                                }}
                                            >
                                                <div style={{ width: "25%", borderRight: "1px solid gray", borderBottom: "1px solid gray", }}>
                                                    <GrammarlyEditorPlugin>
                                                        <input
                                                            style={{ border: "none", width: "95%", background: "none", textAlign: "center", marginTop: "10px" }}
                                                            value={list?.name}
                                                            onChange={(e: any) =>
                                                                updateRow(index, "name", e.target.value, list)

                                                            }
                                                        />
                                                    </GrammarlyEditorPlugin>
                                                </div>

                                                <div
                                                    style={{ width: "15%", borderRight: "1px solid gray", textAlign: "left", borderBottom: "1px solid gray", }}
                                                >
                                                    <GrammarlyEditorPlugin>
                                                        <input
                                                            style={{ border: "none", width: "95%", background: "none", marginTop: "10px", textAlign: "center" }}
                                                            value={list?.varientdetected}
                                                            onChange={(e: any) =>
                                                                updateRow(index, "varientdetected", e.target.value, list)

                                                            }
                                                        />
                                                    </GrammarlyEditorPlugin>
                                                </div>
                                                <div
                                                    style={{ width: "15%", borderRight: "1px solid gray", textAlign: "left", borderBottom: "1px solid gray", }}
                                                >
                                                    <GrammarlyEditorPlugin>
                                                        <input
                                                            style={{ border: "none", width: "100%", background: "none", marginTop: "10px", textAlign: "center" }}
                                                            value={list?.genotype}
                                                            onChange={(e: any) =>
                                                                updateRow(index, "genotype", e.target.value, list)

                                                            }
                                                        />
                                                    </GrammarlyEditorPlugin>

                                                </div>
                                                <div
                                                    style={{ width: "25%", borderRight: "1px solid gray", textAlign: "left", borderBottom: "1px solid gray", }}
                                                >
                                                    <GrammarlyEditorPlugin>
                                                        <input
                                                            style={{ border: "none", width: "100%", background: "none", marginTop: "10px", textAlign: "center" }}
                                                            value={list?.allelestatus}
                                                            onChange={(e: any) =>
                                                                updateRow(index, "allelestatus", e.target.value, list)

                                                            }
                                                        />

                                                    </GrammarlyEditorPlugin>
                                                </div>
                                                <div
                                                    style={{ width: "25%", textAlign: "left", borderBottom: "1px solid gray", }}
                                                >
                                                    <GrammarlyEditorPlugin>
                                                        <input
                                                            style={{ border: "none", width: "95%", background: "none", marginTop: "10px", textAlign: "center" }}
                                                            value={list?.clinical}
                                                            onChange={(e: any) =>
                                                                updateRow(index, "clinical", e.target.value, list)

                                                            }
                                                        />
                                                    </GrammarlyEditorPlugin>
                                                </div>

                                            </div>

                                        </>
                                    );
                                })}
                        </div>
                    </div>
                    <br />
                    <div className="Hbb-clinical__indicatio" >
                        <span
                            className="Hbb-clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            INTERPRETATION
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div>
                        {HbbInterpretation.map((list: any, index: number) => {
                            return (
                                <div style={{ width: "100%", padding: 15, textAlign: "left", fontSize: "17px", marginLeft: "35px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none", wordBreak: "break-word", width: "95%", }}
                                            rows={6}
                                            cols={112}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateInterpretation(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            );
                        })}
                    </div>


                    {/* doctor sign */}
                    <div
                        style={{
                            width: '89%',
                            display: 'flex',
                            padding: 0,
                            margin: 0,
                            justifyContent: 'space-around',
                            marginTop: '5px',
                        }}
                    >
                        {HbbdoctorList &&
                            HbbdoctorList?.length > 0 &&
                            HbbdoctorList?.map((list: any, index: number) => {
                                return (
                                    <>
                                        <img
                                            alt="description of image"
                                            style={{ width: '100px', height: '50px', marginLeft: '85px' }}
                                            src={list?.parameter_url}
                                        />
                                    </>
                                );
                            })}
                    </div>
                    <div style={{ width: '97%', display: 'flex', alignItems: 'left', marginLeft: '18px' }}>
                        {HbbdoctorList &&
                            HbbdoctorList?.length > 0 &&
                            HbbdoctorList?.map((list: any, index: number) => {
                                return (
                                    <>

                                        <textarea
                                            style={{ border: 'none', resize: 'none', textAlign: 'center' }}
                                            rows={4}
                                            cols={140}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateDoctorList(list?.id, e.target.value, index, 'free_text', list)}
                                        />
                                    </>
                                );
                            })}
                    </div>

                    <div className="Hbb-main-content2">.</div>
                    <div className="Hbb-main-content4">.</div>
                    <div className="Hbb-br">.</div>

                    <div
                        style={{
                            fontWeight: "bold",
                            fontSize: "15px",
                            borderTopRightRadius: "20px",
                            borderBottomRightRadius: "20px",
                            background: "rgb(238, 238, 238)",
                            textAlign: "left",
                            marginTop: "20px",
                            width: "500px",
                            height: "40px",
                            padding: "10px",
                            paddingLeft: "40px",
                            borderRight: "1px solid rgb(22 55 88)",
                            borderBottom: "1px solid rgb(22 55 88)",
                            borderTop: "1px solid rgb(22 55 88)"

                        }}
                        className="marginleft-b">
                        Patient Name:&nbsp;&nbsp;{HbbReport[0]?.designation}&nbsp;{HbbReport[0]?.customer_name}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Patient Id:&nbsp;&nbsp;{HbbReport[0]?.pk}
                    </div>

                    <div className="Hbb-br">.</div>

                    {/* <div className="Hbb-br">.</div> */}
                    <div className="Hbb-clinical__indicatio" >
                        <span
                            className="Hbb-clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            RECOMMENDATION
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div>
                        {HbbRecommandation.map((list: any, index: number) => {
                            return (
                                <div style={{ width: "45%", padding: 15, textAlign: "left", fontSize: "17px", marginLeft: "35px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none" }}
                                            rows={4}
                                            cols={112}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateRecommendation(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            );
                        })}
                    </div>
                    <div className="Hbb-br">.</div>
                    <div className="Hbb-clinical__indicatio" >
                        <span
                            className="Hbb-clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            TECHNOLOGY
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div style={{ width: "93%", marginLeft: "50px", fontSize: "17px", wordBreak: "break-word", hyphens: "auto", }}>
                        <p>
                            Sanger sequencing based DNA analysis was performed to identify the mutations in the coding regions and reported mutations in the non-
                            coding regions of β Globin gene (HBB). DNA was isolated from the sample received using a commercial kit that works on the silica- mem
                            brane based DNA purification. Mutation surveyor software V5.1.1 is used for identifying the mutations and the identified sequence

                            alterations are reported in accordance with the Human Genome Variants Society (HGVS) nomenclature and annotated using one or more
                            of the following database/s- ClinVar, OMIM, HGMD and SwissVar.
                        </p>
                    </div>
                    <div className="Hbb-br">.</div>
                    <div className="Hbb-clinical__indicatio" >
                        <span
                            className="Hbb-clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            UNDERSTANDING THE RESULTS
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    {/* </div> */}
                    <table style={{ marginLeft: "40px", background: "#e8eded", color: "  rgb(5, 57, 110)", fontWeight: "bold", fontSize: "18px", height: "55px", textAlign: "center", border: "1px solid gray", width: "92%" }}>

                        <tr >
                            <th style={{ borderRight: "1px solid gray", height: "50px", borderBottom: "1px solid gray" }}>Mutation Type</th>
                            <th style={{ borderRight: "1px solid gray", borderBottom: "1px solid gray" }}>Possible Genotype*</th>
                            <th style={{ borderRight: "1px solid gray", borderBottom: "1px solid gray", }}>Clinical Significance#</th>
                        </tr>
                        <tr>
                            <td style={{ borderRight: "1px solid gray" }}> </td>
                            <td style={{ borderRight: "1px solid gray" }}>β+β+</td>
                            <td style={{ borderRight: "1px solid gray" }}>Thalassemia Intermedia / Major</td>
                        </tr>
                        <tr>
                            <td style={{ borderRight: "1px solid gray" }}> β+ type</td>
                            <td style={{ borderRight: "1px solid gray" }}>β+β0</td>
                            <td style={{ borderRight: "1px solid gray" }}>Thalassemia Major</td>
                        </tr>
                        <tr>
                            <td style={{ borderRight: "1px solid gray" }}> </td>
                            <td style={{ borderRight: "1px solid gray" }}>β+β</td>
                            <td style={{ borderRight: "1px solid gray" }}>Thalassemia Minor</td>
                        </tr>
                        <tr>
                            <td style={{ borderRight: "1px solid gray", borderBottom: "1px solid gray" }}> </td>
                            <td style={{ borderRight: "1px solid gray", borderBottom: "1px solid gray" }}>ββ</td>
                            <td style={{ borderRight: "1px solid gray", borderBottom: "1px solid gray" }}>Normal</td>
                        </tr>
                        <tr style={{ width: "40%" }}>
                            <td style={{ borderRight: "1px solid gray" }}> </td>
                            <td style={{ borderRight: "1px solid gray" }}>β0β0</td>
                            <td style={{ borderRight: "1px solid gray" }}>Thalassemia Major</td>
                        </tr>
                        <tr style={{ width: "40%" }}>
                            <td style={{ borderRight: "1px solid gray" }}> β0 Type</td>
                            <td style={{ borderRight: "1px solid gray" }}>β+β0</td>
                            <td style={{ borderRight: "1px solid gray" }}>Thalassemia Major</td>
                        </tr>
                        <tr style={{ width: "40%" }}>
                            <td style={{ borderRight: "1px solid gray" }} > </td>
                            <td style={{ borderRight: "1px solid gray" }}>β0β</td>
                            <td style={{ borderRight: "1px solid gray" }}>Thalassemia Minor</td>
                        </tr>
                        <tr style={{ width: "40%" }}>
                            <td style={{ borderRight: "1px solid gray" }}> </td>
                            <td style={{ borderRight: "1px solid gray" }}>ββ</td>
                            <td style={{ borderRight: "1px solid gray" }}>Normal </td>
                        </tr>

                    </table>


                    <div className="Hbb-br">.</div>
                    <div style={{ width: "93%", textAlign: "left", fontSize: "17px", marginLeft: "35px", fontWeight: "bold" }}>
                        <p>
                            *β type- Normal functional haemoglobin, β+ type Mutation: Reduced ability to produce β Globin protein with reduced functional capacity for hemoglobin, β0 type mutation: No β Globin will be produced and dysfunctional haemoglobin.
                        </p>
                    </div>
                    <div style={{ width: "93%", textAlign: "left", fontSize: "17px", marginLeft: "35px", fontWeight: "bold" }}>
                        <p>
                            #Thalassemia minor: Patient with one normal copy of the β-Globin gene and may show mild to no symptoms for Thalassemia, Thalassemia major: Patient with both abnormal copies of the β Globin gene and may show acute symptoms for Thalassemia, Thalassemia intermedia; Patient with both abnormal copies of the β Globin gene and may show acute symptoms for Thalassemia at adult stage.
                        </p>
                    </div>


                    <div className="Hbb-br">.</div>
                    {/* <div className="Hbb-br">.</div> */}

                    {/* <div className="Hbb-main-content4">.</div> */}
                    {/* <div className="Hbb-main-content3">.</div> */}
                    {/* doctor sign */}
                    <div
                        style={{
                            width: '89%',
                            display: 'flex',
                            padding: 0,
                            margin: 0,
                            justifyContent: 'space-around',
                            marginTop: '30px',
                        }}
                    >
                        {HbbdoctorList &&
                            HbbdoctorList?.length > 0 &&
                            HbbdoctorList?.map((list: any, index: number) => {
                                return (
                                    <>
                                        <img
                                            alt="description of image"
                                            style={{ width: '100px', height: '50px', marginLeft: '85px' }}
                                            src={list?.parameter_url}
                                        />
                                    </>
                                );
                            })}
                    </div>
                    <div style={{ width: '97%', display: 'flex', alignItems: 'left', marginLeft: '18px' }}>
                        {HbbdoctorList &&
                            HbbdoctorList?.length > 0 &&
                            HbbdoctorList?.map((list: any, index: number) => {
                                return (
                                    <>
                                        <textarea
                                            style={{ border: 'none', resize: 'none', textAlign: 'center' }}
                                            rows={5}
                                            cols={140}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateDoctorList(list?.id, e.target.value, index, 'free_text', list)}
                                        />
                                    </>
                                );
                            })}
                    </div>
                    <div className="Hbb-main-content2">.</div>
                    <div className="Hbb-main-content4">.</div>

                    <div
                        style={{
                            fontWeight: "bold",
                            fontSize: "15px",
                            borderTopRightRadius: "20px",
                            borderBottomRightRadius: "20px",
                            background: "rgb(238, 238, 238)",
                            textAlign: "left",
                            marginTop: "20px",
                            width: "500px",
                            height: "40px",
                            padding: "10px",
                            paddingLeft: "40px",
                            borderRight: "1px solid rgb(22 55 88)",
                            borderBottom: "1px solid rgb(22 55 88)",
                            borderTop: "1px solid rgb(22 55 88)"

                        }}
                        className="marginleft-b">
                        Patient Name:&nbsp;&nbsp;{HbbReport[0]?.designation}&nbsp;{HbbReport[0]?.customer_name}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Patient Id:&nbsp;&nbsp;{HbbReport[0]?.pk}
                    </div>
                    <div className="Hbb-br">.</div>

                    <div className="Hbb-clinical__indicatio" >
                        <span
                            className="Hbb-clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            DISCLAIMER
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div style={{ width: "93%", marginLeft: "50px", fontSize: "17px", wordBreak: "break-word", hyphens: "auto", }}>
                        <p>
                            This test does not distinguish between the alleles present in cis and trans forms. Classification of haemoglobin disorders by genetic data
                            alone may result in incomplete conclusions which may significantly impact overall disorder classification and expected phenotype. The test
                            results does not mean that the risk of carrying or developing Thalassemia/sickle cell anemia is not present and or caused by other known
                            or unknown variations in the genome. Correlation with haemoglobin electrophoresis, red blood cell indices and clinical/family history is
                            required.
                            <br />
                            <b> Limitations:</b> This test will detect greater than 99% of variants in HBB gene excluding large insertions and deletions, which may be
                            a rare phenomenon. Any change in primer binding site can result can interfere with the results and allele dropout cannot be ruled out using
                            this experiment. Benign variants will be provided upon request. The current assay doesn’t detect the delta beta inversion deletion mutation
                            or any other mutation on Delta, Gamma and Alpha gene.
                        </p>
                    </div>

                    <div className="Hbb-clinical__indicatio" >
                        <span
                            className="Hbb-clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            REFERENCE
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div style={{ width: "93%", marginLeft: "50px", fontSize: "17px", wordBreak: "break-word", hyphens: "auto", }}>
                        <p>
                            Colah R, Gorakshakar A, Nadkarni A, Phanasgaonkar S, Surve R, Sawant P, Mohanty D, Ghosh K (2009) Regional heterogeneity of bthalassemia mutations in the multi ethnic
                            Indian population. Blood Cells Mol Dis 42:241–246.


                        </p>
                        <p>
                            Edison ES, Shaji RV, Devi SG, Moses A, Viswabandhya A, Matthews V, George B, Srivastava A,Chandy M (2008) Analysis of b globin mutations in the Indian population: presence
                            of rare and novel mutations and region-wise heterogeneity. ClinGenet 73:331–337.
                            http://globin.bx.psu.edu/hbvar/menu.html
                        </p>

                    </div>
                    <br />

                    {/* doctor sign */}
                    <div className="Hbb-main-content3">.</div>
                    <div className="Hbb-main-content3">.</div>
                    <div className="Hbb-main-content4">.</div>
                    <div className="Hbb-br">.</div>
                    <div style={{ width: "95%", marginLeft: "30px" }}>
                        <p style={{ color: "white", backgroundColor: "#e30b2c", textAlign: "center", marginTop: "20px" }}>Important: As per the PRE-NATAL DIAGNOSTIC TECHNIQUES (REGULATIONS & PREVENTION OF MISUSE) AMENDMENT ACT 2002, sex determination shall not be done for all prenatal samples.</p>
                    </div>
                    <div
                        style={{
                            width: '89%',
                            display: 'flex',
                            padding: 0,
                            margin: 0,
                            justifyContent: 'space-around',
                            marginTop: '30px',
                        }}
                    >
                        {HbbdoctorList &&
                            HbbdoctorList?.length > 0 &&
                            HbbdoctorList?.map((list: any, index: number) => {
                                return (
                                    <>
                                        <img
                                            alt="description of image"
                                            style={{ width: '100px', height: '50px', marginLeft: '85px' }}
                                            src={list?.parameter_url}
                                        />
                                    </>
                                );
                            })}
                    </div>
                    <div style={{ width: '97%', display: 'flex', alignItems: 'left', marginLeft: '18px' }}>
                        {HbbdoctorList &&
                            HbbdoctorList?.length > 0 &&
                            HbbdoctorList?.map((list: any, index: number) => {
                                return (
                                    <>
                                        <textarea
                                            style={{ border: 'none', resize: 'none', textAlign: 'center' }}
                                            rows={5}
                                            cols={140}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateDoctorList(list?.id, e.target.value, index, 'free_text', list)}
                                        />
                                    </>
                                );
                            })}
                    </div>

                    {/* footer section starting */}
                    <div className="Hbb-page-footer">
                        {/* footer area */}

                        <div style={{ padding: '20px' }}>


                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    background: "#fff",
                                }}
                            >

                                <div style={{ width: "15%", textAlign: "left", padding: 15 }}>
                                    <h3>
                                        <QRCode value={`https://lead.redcliffelabs.com/verify-report/?booking=${uuid}&api_key=pvkbv24f916fa28-dd38-4ba5-ad6c-8a78d0`} size={110} />
                                    </h3>
                                </div>
                                <div
                                    style={{
                                        width: "85%",
                                        textAlign: "left",
                                        padding: 10,
                                        marginTop: "-3px",
                                    }}
                                >
                                    <div
                                        style={{ width: "100%", display: "flex", margin: "10px 0px" }}
                                    >
                                        <div style={{ width: "33%", marginLeft: 8 }}>
                                            <img
                                                src={callIcon}
                                                alt="logo"
                                                style={{ width: "20px", margin: "2px" }}
                                            />{" "}
                                            <span style={{ color: "red" }}>
                                                <b>931-126-1989</b>
                                            </span>
                                        </div>
                                        <div style={{ width: "33%", marginLeft: 8 }}>
                                            <img
                                                src={maillIcon}
                                                alt="logo"
                                                style={{ width: "20px", margin: "2px" }}
                                            />
                                            <span style={{ color: "red" }}>
                                                <b>geneticcounselors@redcliffelabs.com</b>
                                            </span>
                                        </div>
                                        <div style={{ width: "33%", marginLeft: "68px" }}>
                                            <img
                                                src={browserIcon}
                                                alt="logo"
                                                style={{ width: "20px", margin: "2px" }}
                                            />
                                            <span style={{ color: "red" }}>
                                                <b>www.redcliffelabs.com</b>
                                            </span>
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            margin: "10px 0px",
                                            textAlign: "left",
                                        }}
                                    >
                                        <h5 style={{ marginLeft: "16px" }}>
                                            {" "}
                                            <b>
                                                Redcliffe Lifetech Pvt. Ltd, H-31, Sector- 63, Noida,
                                                Uttar Pradesh, 201301
                                            </b>
                                        </h5>
                                    </div>
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            margin: "10px 0px",
                                            marginLeft: "16px",
                                            textAlign: "left",
                                        }}
                                    >
                                        <p style={{ fontSize: "13px", marginTop: "-8px" }}>
                                            {" "}
                                            All Lab are subjected to clinical interpretations by
                                            qualified medical professional and this report is not
                                            subject to use for any medico-legal purpose.
                                        </p>
                                    </div>
                                    <hr
                                        style={{
                                            backgroundColor: "red",
                                            width: "100%",
                                            height: "8px",
                                            marginTop: "10px",
                                        }}
                                        className="Hbb-box"
                                    />
                                </div>
                            </div>
                        </div>
                        {/* footer area closed */}
                    </div>
                                        {
                                                                uuid && (
                                                                    <div className="hide-section-rating">
                                                                        <NpsRating bookingId={firstP} uuid={uuid} />
                                                                    </div>
                                                                )
                                                            }
                </div>
            </div >
        </Grammarly >
    );
};
const mapStateToProps = (state: any) => ({
    reportListParameter: state.LimsAdminReducer.reportListParameter,
});

export default connect(mapStateToProps, {
    getReportTemplateParameter,
    createNewReport,
    updateReport,
    getUpdatedCustomerReportData,
    updateNiptDob,
    createNiptDob,
})(HbbReport);

function setInputValues(arg0: (prevState: any) => any) {
    throw new Error("Function not implemented.");
}